import React from 'react'
import { createBrowserRouter, Navigate, Outlet, RouterProvider, useParams } from 'react-router-dom'
import { Alert, Box, Button, CssBaseline, LinearProgress, ThemeProvider } from '@mui/material'
import { getQualityCapabilities } from './utils/permisos'
import { LoginPage } from './components/auth/LoginPage'
import { AppShell } from './components/layout/AppShell'
import { SuiteSessionProvider, useSuiteSession } from './context/SuiteSessionContext'
import { QualityHistory } from './pages/QualityHistory'
import { QualityProduction } from './pages/QualityProduction'
import { appTheme } from './theme/theme'
import { UnsavedChangesProvider } from './components/layout/UnsavedChangesProvider'
import './App.css'

const QualityEntry = () => {
  const { session } = useSuiteSession()
  const { controlId } = useParams()
  return getQualityCapabilities(session).canWrite ? <QualityProduction controlId={controlId} /> : <Navigate to="/historial" replace />
}

const router = createBrowserRouter([{
  element: <UnsavedChangesProvider><AppShell><Outlet /></AppShell></UnsavedChangesProvider>,
  children: [
    { path: '/', element: <QualityEntry /> },
    { path: '/controles/:controlId', element: <QualityEntry /> },
    { path: '/historial', element: <QualityHistory /> },
    { path: '*', element: <Navigate to="/" replace /> },
  ],
}])

const SessionGate = () => {
  const { status, session, logout } = useSuiteSession()
  const { canRead } = getQualityCapabilities(session)

  if (status === 'loading') {
    return (
      <Box className="quality-login-page">
        <Box className="quality-login-loading">
          <LinearProgress />
        </Box>
      </Box>
    )
  }

  if (status !== 'authenticated') {
    return <LoginPage />
  }

  if (!canRead) {
    return <Box sx={{ p: 3 }}><Alert severity="warning">Tu usuario no tiene permiso para consultar Control de Calidad.</Alert><Button onClick={logout}>Cerrar sesion</Button></Box>
  }

  return <RouterProvider router={router} />
}

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <SuiteSessionProvider>
        <SessionGate />
      </SuiteSessionProvider>
    </ThemeProvider>
  )
}

export default App
